import React from "react"

import { Header, Title, SearchBar } from "./styles"

const HeaderWithSearch = ({ searchQuery, setSearchQuery, title, label }) => (
  <Header>
    <Title text={title} />
    <SearchBar
      value={searchQuery}
      onChange={(event) => setSearchQuery(event.target.value)}
      aria-label={label}
    />
  </Header>
)

export default HeaderWithSearch
